/**
 * Bridge between the user's saved appearance preference (system / light / dark)
 * and the CSS variables that ThemeContext writes inline.
 *
 * ThemeContext writes dark-mode variables inline on <html>, and CSS specificity
 * guarantees inline styles beat any :root[data-appearance="light"] block. So
 * when the user picks Light we have to write light-mode variables inline as
 * well, using the same names.
 */

const LIGHT_VARS = {
  "--bg-base":       "#FAFAF7",
  "--bg-surface":    "#FFFFFF",
  "--bg-elevated":   "#F1F1EE",
  "--bg-muted":      "#F5F5F2",
  "--border-line":   "#E4E4E1",
  "--text-primary":  "#0F0F0F",
  "--text-secondary":"#3F3F3F",
  "--text-tertiary": "#737373",
  "--text-muted":    "#737373",
  "--hover":         "rgba(255, 90, 31, 0.10)",
  "--input-bg":      "#FFFFFF",
  "--input-fg":      "#0F0F0F",
  "--input-border":  "#D4D4D0",
};

export function applyAppearance(mode, font) {
  const doc = document.documentElement;
  const isSystem = mode === "system";
  const prefersLight = isSystem && window.matchMedia?.("(prefers-color-scheme: light)").matches;
  const useLight = mode === "light" || prefersLight;

  doc.setAttribute("data-appearance", mode || "dark");
  if (font) doc.style.setProperty("--app-font", `'${font}'`);

  if (useLight) {
    Object.entries(LIGHT_VARS).forEach(([k, v]) => doc.style.setProperty(k, v));
    document.body.style.background = LIGHT_VARS["--bg-base"];
  } else {
    Object.keys(LIGHT_VARS).forEach((k) => doc.style.removeProperty(k));
    document.body.style.background = "";
  }
}

// Called from AuthContext on logout so the next user isn't stuck with the previous appearance.
export function resetAppearance() {
  const doc = document.documentElement;
  doc.removeAttribute("data-appearance");
  doc.style.removeProperty("--app-font");
  Object.keys(LIGHT_VARS).forEach((k) => doc.style.removeProperty(k));
  document.body.style.background = "";
}
